import { render, staticRenderFns } from "./approveTicketVoucher.vue?vue&type=template&id=aed40e5a&lang=pug"
import script from "./approveTicketVoucher.vue?vue&type=script&lang=js"
export * from "./approveTicketVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports